import clsx from "clsx";

/**
 * The official clinic logo, used verbatim. It has a light (cream) ground, so on
 * dark surfaces it sits inside a small rounded plate to read as intentional.
 */
export function BrandLogo({ className, height = 40, plate = true }: { className?: string; height?: number; plate?: boolean }) {
  return (
    <span
      className={clsx("inline-flex items-center justify-center", plate && "rounded-lg bg-[#f6efe0] px-2.5 py-1.5", className)}
    >
      <img
        src="/logo.jpg"
        alt="The Longevity Health Clinic"
        style={{ height, width: "auto" }}
        className="block select-none"
        draggable={false}
      />
    </span>
  );
}

/** Just the tree emblem from the logo, for tight spaces. */
export function BrandMark({ className, size = 28, plate = true }: { className?: string; size?: number; plate?: boolean }) {
  return (
    <span
      className={clsx("inline-flex items-center justify-center", plate && "rounded-md bg-[#f6efe0] p-1", className)}
      style={{ width: plate ? size + 8 : size, height: plate ? size + 8 : size }}
    >
      <img src="/logo-mark.jpg" alt="" style={{ height: size, width: "auto" }} className="block select-none" draggable={false} />
    </span>
  );
}
